{
    "Accessibility Menu": "תפריט נגישות",
    "Reset settings": "איפוס הגדרות",
    "Close": "סגור",
    "Content Adjustments": "התאמות תוכן",
    "Adjust Font Size": "התאם גודל פונט",
    "Highlight Title": "הדגש כותרת",
    "Highlight Links": "הדגש קישורים",
    "Readable Font": "פונט קריא",
    "Color Adjustments": "התאמות צבע",
    "Dark Contrast": "ניגודיות כהה",
    "Light Contrast": "ניגודיות בהירה",
    "High Contrast": "ניגודיות גבוהה",
    "High Saturation": "רווי צבע גבוה",
    "Low Saturation": "רווי צבע נמוך",
    "Monochrome": "מונוכרום",
    "Protanopia": "פרוטנופיה",
    "Deuteranopia": "דאוטרנופיה",
    "Tritanopia": "טריטנופיה",
    "Visual & Navigation Aids": "עזרי ניווט וראייה",
    "Additional Tools": "כלים נוספים",
    "Reading Guide": "מדריך קריאה",
    "Stop Animations": "עצירת אנימציות",
    "Big Cursor": "סמן גדול",
    "Screen Reader": "קורא מסך",
    "Hide Images": "הסתר תמונות",
    "Image Tooltips": "הסברים לתמונות",
    "Page Structure": "מבנה העמוד",
    "Super Focus": "סופר פוקוס",
    "Magnifier": "זכוכית מגדלת",
    "Increase Font Size": "הגדל גודל פונט",
    "Decrease Font Size": "הקטן גודל פונט",
    "Letter Spacing": "מרווח בין אותיות",
    "Line Height": "גובה שורה",
    "Font Weight": "משקל הפונט",
    "Dyslexia Font": "פונט לדיסלקטים",
    "Language": "שפה",
    "Open Accessibility Menu": "פתח תפריט נגישות",
    "Accessibility Profiles": "פרופילי נגישות",
    "Seizure Safe Profile": "פרופיל בטוח לאפילפטיים",
    "Stops animations and reduces color saturation.": "עוצר אנימציות ומפחית רוויית צבע.",
    "Blind Profile": "פרופיל לעיוורים",
    "Activates the screen reader for auditory navigation.": "מפעיל קורא מסך לניווט קולי.",
    "Visually Impaired Profile": "פרופיל לכבדי ראייה",
    "Enhances contrast and readability for low vision.": "משפר ניגודיות וקריאות לכבדי ראייה.",
    "ADHD Friendly Profile": "פרופיל ידידותי ל-ADHD",
    "Reduces distractions for better focus.": "מפחית הסחות דעת לריכוז טוב יותר.",
    "Cognitive & Learning Profile": "פרופיל קוגניטיבי ולמידה",
    "Helpful tools for reading and comprehension.": "כלים שימושיים לקריאה והבנה.",
    "Motor Impaired Profile": "פרופיל לעם לקות מוטורית",
    "Optimizes the site for keyboard-only navigation.": "מייעל את האתר לניווט עם מקלדת בלבד.",
    "Headings": "כותרות",
    "Landmarks": "אבני דרך",
    "Links": "קישורים",
    "Focus element": "התמקד ברכיב",
    "Visit link": "בקר בקישור"
}